import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { __ } from "services/Translator";
import api from "services/api";

export default function RankSlider(props) {
  //Rank slider
  const nextLoad = () => {
    ranksRef.current.slickNext();
  };

  const prevLoad = () => {
    ranksRef.current.slickPrev();
  };

  const ranksSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: false,
    customPaging: function (i) {
      return (
        <a className={props.landingType}>
          <div className="round">
            <i class="fas fa-circle"></i>
          </div>
          <div className="line"></div>
        </a>
      );
    },
    dotsClass: "slick-dots deposit_slider_dots",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          className: "center",
          centerMode: true,
        },
      },
    ],
  };

  const ranksRef = useRef();
  return (
    <section className="rank-area">
      <div className="rankArea">
        <div className="section_headline">
          <div className="headline_text">{__("Ranks")}</div>
          <div className="headline_action">
            <button onClick={prevLoad} className="action_btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="20"
                fill="white"
                class="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
              {__("Prev")}
            </button>
            <button onClick={nextLoad} className="action_btn">
              {__("Next")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="20"
                fill="white"
                class="bi bi-arrow-right"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div className="tier-cards-container">
        <Slider ref={ranksRef} {...ranksSettings}>
          <div className="slide-item">
            <div className="tier-card">
              <div className="tier-icon">
                <img
                  src={require("assets/images/rewards/one.png").default}
                  alt={` icon`}
                />
              </div>
              <label className="labelBtn">{__("Gold I")}</label>
              <div className="clearfix"></div>
              <ul className="tier-details">
                <li>
                  <strong>Wheel:</strong> wheel
                </li>
                <li>
                  <strong>Cashback:</strong> cashback%
                </li>
                <li>
                  <strong>Rakeback:</strong> rakeback%
                </li>
                <li>
                  <strong>Personal VIP Manager:</strong> vipManager
                </li>
                <li>
                  <strong>Free Spin:</strong> freeSpin
                </li>
                <li>
                  <strong>Bonus:</strong> bonus
                </li>
              </ul>
            </div>
          </div>
          <div className="slide-item">
            <div className="tier-card">
              <div className="tier-icon">
                <img
                  src={require("assets/images/rewards/two.png").default}
                  alt={` icon`}
                />
              </div>
              <label className="labelBtn">{__("Gold I")}</label>
              <div className="clearfix"></div>
              <ul className="tier-details">
                <li>
                  <strong>Wheel:</strong> wheel
                </li>
                <li>
                  <strong>Cashback:</strong> cashback%
                </li>
                <li>
                  <strong>Rakeback:</strong> rakeback%
                </li>
                <li>
                  <strong>Personal VIP Manager:</strong> vipManager
                </li>
                <li>
                  <strong>Free Spin:</strong> freeSpin
                </li>
                <li>
                  <strong>Bonus:</strong> bonus
                </li>
              </ul>
            </div>
          </div>
          <div className="slide-item">
            <div className="tier-card">
              <div className="tier-icon">
                <img
                  src={require("assets/images/rewards/three.png").default}
                  alt={` icon`}
                />
              </div>
              <label className="labelBtn">{__("Gold I")}</label>
              <div className="clearfix"></div>
              <ul className="tier-details">
                <li>
                  <strong>Wheel:</strong> wheel
                </li>
                <li>
                  <strong>Cashback:</strong> cashback%
                </li>
                <li>
                  <strong>Rakeback:</strong> rakeback%
                </li>
                <li>
                  <strong>Personal VIP Manager:</strong> vipManager
                </li>
                <li>
                  <strong>Free Spin:</strong> freeSpin
                </li>
                <li>
                  <strong>Bonus:</strong> bonus
                </li>
              </ul>
            </div>
          </div>
          <div className="slide-item">
            <div className="tier-card">
              <div className="tier-icon">
                <img
                  src={require("assets/images/rewards/four.png").default}
                  alt={` icon`}
                />
              </div>
              <label className="labelBtn">{__("Gold I")}</label>
              <div className="clearfix"></div>
              <ul className="tier-details">
                <li>
                  <strong>Wheel:</strong> wheel
                </li>
                <li>
                  <strong>Cashback:</strong> cashback%
                </li>
                <li>
                  <strong>Rakeback:</strong> rakeback%
                </li>
                <li>
                  <strong>Personal VIP Manager:</strong> vipManager
                </li>
                <li>
                  <strong>Free Spin:</strong> freeSpin
                </li>
                <li>
                  <strong>Bonus:</strong> bonus
                </li>
              </ul>
            </div>
          </div>
          <div className="slide-item">
            <div className="tier-card">
              <div className="tier-icon">
                <img
                  src={require("assets/images/rewards/five.png").default}
                  alt={` icon`}
                />
              </div>
              <label className="labelBtn">{__("Gold I")}</label>
              <div className="clearfix"></div>
              <ul className="tier-details">
                <li>
                  <strong>Wheel:</strong> wheel
                </li>
                <li>
                  <strong>Cashback:</strong> cashback%
                </li>
                <li>
                  <strong>Rakeback:</strong> rakeback%
                </li>
                <li>
                  <strong>Personal VIP Manager:</strong> vipManager
                </li>
                <li>
                  <strong>Free Spin:</strong> freeSpin
                </li>
                <li>
                  <strong>Bonus:</strong> bonus
                </li>
              </ul>
            </div>
          </div>
          <div className="slide-item">
            <div className="tier-card">
              <div className="tier-icon">
                <img
                  src={require("assets/images/rewards/four.png").default}
                  alt={` icon`}
                />
              </div>
              <label className="labelBtn">{__("Gold I")}</label>
              <div className="clearfix"></div>
              <ul className="tier-details">
                <li>
                  <strong>Wheel:</strong> wheel
                </li>
                <li>
                  <strong>Cashback:</strong> cashback%
                </li>
                <li>
                  <strong>Rakeback:</strong> rakeback%
                </li>
                <li>
                  <strong>Personal VIP Manager:</strong> vipManager
                </li>
                <li>
                  <strong>Free Spin:</strong> freeSpin
                </li>
                <li>
                  <strong>Bonus:</strong> bonus
                </li>
              </ul>
            </div>
          </div>
          <div className="slide-item">
            <div className="tier-card">
              <div className="tier-icon">
                <img
                  src={require("assets/images/rewards/five.png").default}
                  alt={` icon`}
                />
              </div>
              <label className="labelBtn">{__("Gold I")}</label>
              <div className="clearfix"></div>
              <ul className="tier-details">
                <li>
                  <strong>Wheel:</strong> wheel
                </li>
                <li>
                  <strong>Cashback:</strong> cashback%
                </li>
                <li>
                  <strong>Rakeback:</strong> rakeback%
                </li>
                <li>
                  <strong>Personal VIP Manager:</strong> vipManager
                </li>
                <li>
                  <strong>Free Spin:</strong> freeSpin
                </li>
                <li>
                  <strong>Bonus:</strong> bonus
                </li>
              </ul>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
}
